import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useExperiment } from '@/libraries/experiment';
import {
	ExperimentAffiliationPlacement,
	getExperimentAffiliateTag,
} from '@/libraries/experiment/experiment-affiliation';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';

const ELIGIBLE_PROVIDERS = ['prv', 'amp', 'atp', 'hlu'];

/**
 * Read-only composable for EXP_TITLE_PAGE_CATEGORIZATION.
 * Activation happens once, in the ancestor rendered unconditionally on every title page type
 * (movie/show/season) — see TitleDetailV1.vue — following the "multiple descendant consumers"
 */
export function useTitlePageCategorizationExp() {
	const {
		activeVariantWithControlGroup: variant,
		experimentInfo,
		trackEvent,
	} = useExperiment('EXP_TITLE_PAGE_CATEGORIZATION');

	const { country } = storeToRefs(useLanguageStore());

	function setTitlePageCategorizationExpTags({
		url,
		placement,
		shortName,
	}: {
		url: ClickoutUrl;
		placement: ExperimentAffiliationPlacement;
		shortName: string;
	}) {
		if (!variant.value) return url;
		if (!ELIGIBLE_PROVIDERS.includes(shortName)) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: country.value,
			placement,
			providerShortName: shortName,
		});

		return url.set('uct_ctag', tag);
	}

	return {
		variant,
		trackEvent,
		setTitlePageCategorizationExpTags,
	};
}
